window.sq = window.sq || {};

//to show out of stock below instock starts

// (function (XHR) {
//   "use strict";

//   var open = XHR.prototype.open;
//   var send = XHR.prototype.send;

//   XHR.prototype.open = function (method, url, async, user, pass) {
//     this._url = url;
//     open.call(this, method, url, async, user, pass);
//   };

//   XHR.prototype.send = function (data) {
//     var self = this;
//     var url = this._url;

//     if (url && url.toLowerCase() === "https://gkd2c167wz72e6zyvvluvatj-fast.searchtap.net/v2".toLowerCase()) {
//       const body = JSON.parse(data);
//       //console.log("The body is",body);
      
//       let sorting = body.sort;
//       	sorting.unshift('-in_stock')
//         //console.log("sorting is",sorting)
//       data = JSON.stringify(body);
//     }
//     send.call(this, data);
//   }
// })(XMLHttpRequest);

//to show out of stock below instock ends

(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;
   
    if (
      url &&
      url.toLowerCase() ===
        "https://gkd2c167wz72e6zyvvluvatj-fast.searchtap.net/v2".toLowerCase() //v2 link
    ) {
      const body = JSON.parse(data);
      body.filter += " AND NOT inventory_quantity <= 0"
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);


window.sq.onCartAdded = function () {
  ajaxCart.load();
}

window.sq.onItemComplete = function (el, item) {
  if (Shopify.locale === "en") {
    let atc = el.querySelector('.sq-add-to-cart');
    if (atc) {
      atc.innerText = "Add to Cart"
    }
  }
}

window.sq.onSearchInit = function (query) {
  try {
    let filterQuery = query;
    if (filterQuery) {
      query.filter = query.filter.replace('AND in_stock = 1', '')
    }

    return query;
  } catch (e) { }
}
